<template>        
    <div class="BoxTabellaDettaglio" :id="'contPanel' +  this.contBoxId">
      <div class="Counter">
        <!-- Inizio repeater repeater-->
        <div class="BoxTabellaDettaglio" v-for="(attivita, index) in this.listaAttivita" :key="index">          
            <PannDettInterventiStoricoRiga 
            :attivita="attivita"
            :chiaveIntervento="this.chiaveIntervento"
            :index="index"
            :idCont="'contPanel' +  this.contBoxId"
            >
            </PannDettInterventiStoricoRiga>
        </div>
        <!-- Fine repeater repeater-->
      </div>
  </div>

</template>
<script>
import PannDettInterventiStoricoRiga from "@/components/PannDettInterventiStoricoRiga.vue";
import AttivitaIntervento from "@/models/attivitaIntervento.model.js";
import {apiMixin} from "/mixin.js";

export default {
    name: "PannDettInterventiStorico",
    data(){
      return {
        listaAttivita: null,
        contBoxId:  this.codiceIntervento.replace(" ", "").replace("/", ""),
      }
    },
    mixins:[apiMixin],
    props:{       
        chiaveIntervento: String,
        codiceIntervento: String     
    },
    watch:{
      codiceIntervento: function(newValue){        
        this.contBoxId = newValue.replace(" ", "").replace("/", ""); 
      },     
    },    
    components: {
      PannDettInterventiStoricoRiga
    },  

    created(){    
        let params = {
            CodiceIntervento: this.codiceIntervento
        };
        this.doApiCall("get", "interventi/GetAttivita", this.$store.getters.getUtente.Token, params).then(

            (data) => {                
                if(data){                                          
                    this.listaAttivita = data.map(o => {
                        return Object.assign(new AttivitaIntervento(), o)
                    });                                  
                }                    
                
            }
        );
    } 
}
</script>